export abstract class BaseHandler {

  protected ghostObject: any;

  constructor() {
    this.ghostObject = null;
  }

  setGhostObject(obj) {
    this.ghostObject = obj;
  }

  abstract canExecute(entity): boolean;

  abstract dragBegin(intersection): boolean;

  abstract dragEnd(object);

  abstract getRaycastObjects(): Array<any>;
}



// WEBPACK FOOTER //
// ./src/app/Component(2D and 3D)/3D/ObjectAdd/Handlers/BaseHandler.ts